<template>
    <modal
        :title="data.startAt| moment('dddd, MMMM Do YYYY')"
        :id="id"
        :actionButtons="false"
        size="full"
        :closeButton="true"
        @shown="shown"
    >
        <div class="row">
            <div class="col-md-9">
                <div v-for="(service, serviceIndex) in data.services" :key="serviceIndex">
                    <div class="card mb-1" v-if="service.treatment">
                        <div class="card-body p-2">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <h2 class="m-0">{{ service.startAt| moment('LT')}}</h2>
                                    <p class="text-muted small">{{ service.duration }} {{$t('minutes')}}</p>
                                </div>
                                <div class="col-auto">
                                    <h4 class="card-title mb-1">{{ service.treatment.label }}</h4>
                                    <p class="card-text small text-muted mb-1">{{ service.treatment.description}}</p>
                                </div>

                                <div class="col"></div>
                                <div class="col-auto">
                                    <span class="text-muted">
                                        {{ service.user.firstName }}
                                        {{ service.user.lastName }}
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <h4 class="card-title mb-1">
                                        <money :value="service.treatment.price" />
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 d-flex flex-column">
                <div class="card card-inactive">
                    <div class="inactive card-body p-2" v-if="data.customer">
                        <div class="row align-items-center">
                            <div
                                class="col-auto pointer"
                                @click="$router.push({ name: 'people.customer', params: { id: data.customerId } })"
                            >
                                <avatar
                                    :src="data.customer.avatar.preview"
                                    v-if="data.customer.avatar"
                                    type="circle"
                                    size="avatar-sm"
                                ></avatar>
                            </div>
                            <div
                                class="col ml-n3 pointer"
                                @click="$router.push({ name: 'people.customer', params: { id: data.customerId } })"
                            >
                                <h4 class="card-title mb-1">{{ data.customer.first_name}} {{ data.customer.last_name}}</h4>
                                <p class="card-text small text-muted mb-n1">
                                    <i class="fe fe-phone text-info"></i>
                                    {{data.customer.phone}}
                                </p>
                                <p class="card-text small text-muted" v-if="data.customer.email">
                                    <i class="fe fe-mail text-info"></i>
                                    {{data.customer.email}}
                                </p>
                            </div>
                            <div class="col-auto hidden-sm-down">
                                <a :href="'tel:' + data.customer.phone" class="btn btn-lg">
                                    <i class="fe fe-phone" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btn-block" v-if="!completed">
                    <b-dropdown :variant="status.variant || 'info'" class="btn-block fullwidth">
                        <template slot="button-content" class="btn-block">
                            <i class="fe" :class="status.icon"></i>
                            {{ $t(status.label) }}
                        </template>
                        <b-dropdown-item
                            @click="setStatus(statusKey)"
                            v-for="(statusItem, statusKey) in statusList"
                            :key="statusItem.status"
                        >
                            <i class="fe ml-n3 mr-2" :class="statusItem.icon + ' text-' + statusItem.variant"></i>
                            {{$t(statusItem.label)}}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="mt-auto">
                    <div class="card pointer hover" @click="openCheckoutModal()">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="card-title text-uppercase text-muted mb-2">{{$t('Total')}}</h6>

                                    <span class="h2 mb-0">
                                        <money :value="invoice.totalPrice || data.totalPrice" />
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <!-- Icon -->
                                    <span class="h2 fe fe-dollar-sign text-muted mb-0"></span>
                                </div>
                            </div>
                            <!-- / .row -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col">
                        <div v-if="!completed">
                            <button
                                class="btn btn-white mr-2"
                                v-b-tooltip
                                title="Edit/Reschedule appointment"
                                @click="editAppointment()"
                            >
                                <i class="fe fe-edit"></i>
                            </button>
                            <button
                                class="btn btn-white mr-2"
                                @click="openModal({id:'cancelationModal', model})"
                                v-b-tooltip
                                title="Cancel appointment"
                                v-if="!past"
                            >
                                <i class="fe fe-x-circle text-danger"></i>
                            </button>
                            <button class="btn btn-white mr-2" @click="noShow()" v-b-tooltip title="No show" v-else>
                                <i class="fe fe-eye-off text-danger"></i>
                            </button>
                        </div>
                    </div>

                    <div class="col-auto">
                        <button type="button" @click="close" class="btn btn-white ml-2">{{$t('Close')}}</button>

                        <b-button
                            @click="openCheckoutModal()"
                            v-if="!completed"
                            size="lg"
                            variant="success"
                            class="ml-2"
                        >{{$t('Checkout')}}</b-button>
                        <button
                            type="button"
                            @click="invoiceModal(data.invoiceId, true)"
                            v-else
                            class="btn btn-white ml-2"
                        >{{$t('Invoice')}}</button>
                    </div>
                </div>
            </div>
        </template>
        <confirmation-modal
            text="Cancel appointment?"
            id="cancelationModal"
            :item="model"
            :confirmAction="cancelAppointment"
        ></confirmation-modal>
    </modal>
</template>

<script>

import Modal from "@/components/Modal.vue";
import Avatar from '@/components/Avatar.vue'
import Money from '@/components/Money.vue';
import currency from '@/filters/currency.js';
import status, { statusList } from '@/filters/status.js';
import { modalMixins } from '@/mixins/modal.js';

import CheckoutModal from '@/Pages/Sales/CheckoutModal.vue';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'appointment-view-modal',
    props: ['id', 'appointment'],
    mixins: [modalMixins],
    filters: { currency, status },
    components: {
        Money,
        Modal,
        Avatar,
        ConfirmationModal,
        CheckoutModal,
    },
    data() {
        return {
            loading: false,
            hideForm: false,
            data: {},
            title: 'View Appointment',
        }
    },
    watch: {
        'data.services': {
            handler(items) {
                if (!items) return null;

                let totalPrice = 0;
                let pricing = {
                    services: 0,
                    products: 0
                };

                items.forEach(item => {
                    let price;
                    if (item.treatment) {

                        price = item.treatment.price;
                        pricing.services += price;

                    } else if (item.product) {

                        price = item.product.price.retailPrice;
                        if (item.quantity) {
                            price = price * item.quantity;
                        }
                        pricing.products += price;
                    }
                    totalPrice = totalPrice + price;
                });
                this.$set(this.data, 'totalPrice', totalPrice);
                this.$set(this.data, 'toPay', totalPrice);
                this.$set(this.data, 'pricing', pricing);

            },
            deep: true
        }

    },
    computed: {
        ...mapState('my-team', { isTeamLoading: 'isFindPending' }),
        ...mapGetters('my-team', { findTeamInStore: 'find' }),
        ...mapGetters('customers', { getCustomer: 'get' }),
        ...mapGetters('invoices', { getInvoice: 'get' }),

        invoice() {
            if (!this.data.invoiceId) return {};
            return this.getInvoice(this.data.invoiceId) || this.fetchInvoice(this.data.invoiceId);
        },

        statusList() {
            return statusList;
        },

        completed() {
            return this.data.status == 'completed';
        },
        status() {
            return status(this.data.status);
        },
        past() {
            return this.$moment(this.data.startAt).local() < this.$moment().local()
        },

    },
    methods: {
        ...mapActions('invoices', { fetchInvoice: 'get' }),
        ...mapActions('cart', { removeFromCart: 'remove', fetchCustomerCart: 'find' }),

        editAppointment() {

            let appointment = {
                model: this.appointment,
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex
            new Appointment(appointment);

            this.openModal({ id: 'AppointmentFastModal' });
        },

        openCheckoutModal() {
            if (this.completed) return;
            let details = {
                appointment: this.appointment,
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex;
            new Appointment(details);
            this.openModal({ id: 'CheckoutModal' });
            this.close();
        },

        ...mapActions('appointment', ['create', 'patch']),

        shown() {

            this.data = JSON.parse(JSON.stringify(this.appointment));
            this.$root.$emit('bv::hide::popover');


            //Load data from cart
            this.fetchCustomerCart({ query: { customerId: this.data.customerId } }).then(result => {
                result.data.forEach(item => {
                    this.data.services.push({
                        duration: item.treatments.duration,
                        quantity: 1,
                        treatment: item.treatments,
                        treatmentId: item.treatments._id,
                        user: item.user,
                        userId: item.userId
                    });
                })
            });




        },
        close() {
            this.$root.$emit('bv::hide::modal', this.id);
            this.data = {};
        },
        setStatus(status) {
            this.patch([this.data._id, { status: status }]);
            this.$root.$emit('bv::hide::modal', this.id);
        },
        cancelAppointment() {
            this.setStatus('cancelled');
        },
        noShow() {
            this.setStatus('noshow');
        }


    },

}
</script>
<style>
.fullwidth .dropdown-menu{
    width:100%;
}
</style>
